/**
 * Generate a simple hash from an FCM token to use as a stable DB key.
 * Uses the SubtleCrypto API (available in all modern browsers and service workers).
 */
export async function hashToken(token: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(token);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  // Return first 16 bytes as hex (32 chars) — enough to avoid collisions
  return hashArray
    .slice(0, 16)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Detect the current platform for token metadata.
 */
export function detectPlatform(): string {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  if (/Mac/.test(ua)) return 'macos';
  if (/Windows/.test(ua)) return 'windows';
  if (/Linux/.test(ua)) return 'linux';
  return 'unknown';
}
